<template>
  <v-card class="ma-2 pa-2" color="#dce9fb" outlined>
    <v-card-title>
      Menu Image
      <div class="ml-2">
        <v-btn icon color="green" @click="moveUp()">
          <v-icon>mdi-arrow-up-bold-box</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="moveDown()">
          <v-icon>mdi-arrow-down-bold-box</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-subtitle>
      <div>ID: {{ child.id }}</div>
      <div>Type: {{ child.type }}</div>
      <div>Sort Order: {{ child.sort_order }}</div>
    </v-card-subtitle>
    <v-card-text>
      <div class="d-flex flex-wrap">
        <v-flex xs6>
          <img :src="selectImageBase64 || child.image_url" class="mb-6" style="width: 100%" />
        </v-flex>
        <v-flex xs6 class="pl-4">
          <v-btn fab dark small color="cyan" elevation="1" @click="openImagePicker">
            <v-icon dark>edit</v-icon>
          </v-btn>
          <div class="mt-2">SVG no larger than 1MB</div>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <v-textarea label="Title" v-model="child.title" rows="2"></v-textarea>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <v-text-field label="CTA URL" v-model="child.cta_url" dense></v-text-field>
        </v-flex>
        <v-flex xs12>
          <div class="d-flex align-center">
            <div
              :style="{
                backgroundColor: child.attributes.background_color,
                width: '50px',
                height: '50px',
                marginBottom: '16px',
              }"
            ></div>
            <v-text-field
              label="Background Color"
              class="ml-4"
              v-model="child.attributes.background_color"
              dense
            ></v-text-field>
          </div>
        </v-flex>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="save">Save</v-btn>
    </v-card-actions>
    <input type="file" ref="imageInput" style="display: none" @change="onSelectFile" />
  </v-card>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import homefeedService from '../../../services/homefeed';
import { srcToBase64 } from '../../../utils/stringUtil';
export default Vue.extend({
  props: {
    child: {
      type: Object,
      required: true,
    },
    onChildChange: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectImageFileName: null,
      selectImageBase64: null,
    };
  },
  methods: {
    openImagePicker() {
      this.$refs.imageInput.click();
    },
    onSelectFile(e) {
      const files = e.target.files;
      const file = files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const base64String = event.target.result;
          this.selectImageFileName = file.name;
          this.selectImageBase64 = base64String;
        };
        reader.onerror = (error) => {
          console.error('Error reading file:', error);
        };
        reader.readAsDataURL(file);
      } else {
        console.error('No file selected');
      }
    },
    async save() {
      const requestBody = {
        title: this.child.title,
        cta_url: this.child.cta_url,
        attributes: { background_color: this.child.attributes.background_color },
      };

      if (this.selectImageBase64) {
        requestBody.image_url = {
          image_base64: srcToBase64(this.selectImageBase64),
          image_filename: this.selectImageFileName,
        };
      }

      await homefeedService.updateChild(this.child.section_id, this.child.id, requestBody);
      console.log('Successfully updated child ID:', this.child.id);
    },
    async moveUp() {
      this.$root
        .$confirm('Move child up', `This change will take effect on app immediately.`, { color: 'primary' })
        .then(async (confirm) => {
          if (confirm) {
            await homefeedService.moveChild(this.child.section_id, this.child.id, -1);
            this.onChildChange();
          }
        });
    },
    async moveDown() {
      this.$root
        .$confirm('Move child down', `This change will take effect on app immediately.`, { color: 'primary' })
        .then(async (confirm) => {
          if (confirm) {
            await homefeedService.moveChild(this.child.section_id, this.child.id, 1);
            this.onChildChange();
          }
        });
    },
  },
});
</script>

<style scoped></style>
